<template>
  <div
    ref="cursor"
    class="cursor hidden lg:block"
    :style="cursorCircle"
    :class="{ cursor__hide: hideCursor }"
  >
    <CircleButton icon-name="arrow-right" color="orange" />
  </div>
</template>

<script setup lang="ts">
const positionX = ref(0)
const positionY = ref(0)
const cursor = ref<null | HTMLElement>(null)
const hideCursor = ref(false)
const cursorCircle = computed(
  () =>
    `transform: translateX(${positionX.value === 0 ? -100 : positionX.value}px) translateY(${
      positionY.value
    }px) translateZ(0) translate3d(0, 0, 0);`
)

function moveCursor(e: MouseEvent) {
  useTimeoutFn(() => {
    positionX.value = e.clientX - 15
    positionY.value = e.clientY - 15
  }, 50)
}
function setCursorVisibility(hide: boolean) {
  hideCursor.value = hide
}
onMounted(() => {
  document.addEventListener('mousemove', moveCursor)
  document.addEventListener('mouseleave', () => setCursorVisibility(true))
  document.addEventListener('mouseenter', () => setCursorVisibility(false))
})

onUnmounted(() => {
  document.removeEventListener('mousemove', moveCursor)
  document.removeEventListener('mouseleave', () => setCursorVisibility(true))
  document.removeEventListener('mouseenter', () => setCursorVisibility(false))
})
</script>

<style lang="postcss">
.cursor {
  @apply pointer-events-none fixed left-0 top-0 z-[9999] rounded-full will-change-transform;

  &__hide {
    @apply opacity-0 transition-all duration-500;
  }
}
</style>
